export default "__VITE_ASSET__C4Fqup3H__"